import React from "react";

interface FormatedTimeProps {
  min: any;
}

export const FormatedTime: React.FC<FormatedTimeProps> = ({ min }) => {
  const hours = Math.floor(min / 60);
  const minutes = min % 60;
  const formattedHours = hours < 10 ? `0${hours}` : hours;
  return (
    <>
      {formattedHours} hr : {minutes} mins
    </>
  );
};
